<template>
  <div v-if="value" id="print-1044" class="grid">
    <!-- 표지 -->
    <page1 :header="header" :board="board" :value="value" style="padding: 80px 80px 60px; box-sizing: border-box;"></page1>

    <!-- ① 총괄 현황 / ② 안전관리 추진현황-->
    <page2 :header="header" :board="board" :value="value" style="padding: 80px 80px 60px; box-sizing: border-box; page-break-before: always"></page2>

    <!-- ② 안전관리 추진현황 -->
    <page3 :header="header" :board="board" :value="value" style="padding: 0 80px; box-sizing: border-box;"></page3>

    <!-- ② 안전관리 추진현황 / ③ 관리개선 및 보완사항 -->
    <page4 :header="header" :board="board" :value="value" style="padding: 0 80px; box-sizing: border-box;"></page4>

    <!-- ③ 관리개선 및 보완사항 -->
    <page5 :header="header" :board="board" :value="value" style="padding: 0 80px; box-sizing: border-box;"></page5>

    <!-- ④-1 의무이행사항 점검결과(원료/제조물) -->
    <page6 v-if="usePrint('의무이행사항 점검결과(원료/제조물)')" :header="header" :board="board" :value="value" style="padding: 80px 80px 60px; box-sizing: border-box; page-break-before: always"></page6>

    <!-- ④-2 의무이행사항 점검결과(공중이용시설_직접관리 시설) -->
    <page7 v-if="usePrint('의무이행사항 점검결과(공중이용시설 직접관리 시설)')" :header="header" :board="board" :value="value" style="padding: 80px 80px 60px; box-sizing: border-box; page-break-before: always"></page7>

    <!-- ④-3 의무이행사항 점검결과(공중이용시설_위탁운영 시설) -->
    <page8 v-if="usePrint('의무이행사항 점검결과(공중이용시설 위탁운영 시설)')" :header="header" :board="board" :value="value" style="padding: 80px 80px 60px; box-sizing: border-box; page-break-before: always"></page8>
  </div>
</template>

<script>
import Page1 from "@/views/boards/single-page/1044/print/Page1.vue";
import Page2 from "@/views/boards/single-page/1044/print/Page2.vue";
import Page3 from "@/views/boards/single-page/1044/print/Page3.vue";
import Page4 from "@/views/boards/single-page/1044/print/Page4.vue";
import Page5 from "@/views/boards/single-page/1044/print/Page5.vue";
import Page6 from "@/views/boards/single-page/1044/print/Page6.vue";
import Page7 from "@/views/boards/single-page/1044/print/Page7.vue";
import Page8 from "@/views/boards/single-page/1044/print/Page8.vue";

export default {
  components: {Page8, Page7, Page6, Page5, Page4, Page3, Page2, Page1 },
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
    usePrint(title) {
      if (this.value && this.value.inspectChecked) {
        return this.value.inspectChecked.includes(title)
      }
      return false;
    }
  }
}
</script>

<style lang="scss">
#print-1044 {

  /* 타이틀 */
  h3 {
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0;
    vertical-align: middle;
    color: #ffffff;
  }
  .header26 {
    font-weight: 700;
    font-size: 26px;
    line-height: 170%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #3C3C3C;
  }

  .text-hint {
    font-weight: 400;
    line-height: 170%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #4839EB;
  }

  .bullseye {
    display: inline-block;
    width: 141px;

    font-weight: 700;
    font-size: 26px;
    line-height: 170%;
    letter-spacing: 0;
    vertical-align: middle;

    &::before {
      content: "❍ ";
    }

    &::after {
      content: " :";
    }

    &.none-colon {
      width: 125px;

      &::after {
        content: "";
      }
    }
  }

  .double-border-header {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    padding: 0 !important;
    margin: 0 !important;

    word-break: keep-all;

    td,
    th {
      font-size: 21px;
      padding: 0 !important;
      margin: 0 !important;
      line-height: 25px;
      vertical-align: middle;
    }

    th {
      font-weight: 700;
      text-align: center;

      &.num-title {
        width: 100%;
        font-size: 21px;

        > div {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        span:first-child {
          width: 21.14px;
        }

        span:last-child {
          display: inline-block;
          width: 78px;
          text-align: justify;
          text-align-last: justify;
          text-justify: inter-word;
        }
      }
    }

    tr.border-center {
      th,
      td {
        border-right: 1px solid #757575;
      }

      th:last-child,
      td:last-child {
        border-right: none;
      }
    }
  }
}


</style>
